export const handleChangeInputLoginPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_LOGIN', name, value
});

export const handleChangeProfileData = (info) => ({
    type: 'CHANGE_PROFILE_DATA', info
});

export const handleChangeToken = (token) => ({
    type: 'CHANGE_TOKEN', token
});

export const actionLogOutUser = (token) => ({
    type: 'LOG_OUT_USER', token
});